// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/accessgov.ttf?1mwwnb", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/accessgov.woff?1mwwnb", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/accessgov.svg?1mwwnb", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___, { hash: "#accessgov" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: "accessgov";
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype"),
        url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff"),
        url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("svg");
    font-weight: normal;
    font-style: normal;
    font-display: block;
}

.icon:before {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: "accessgov" !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;

    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.icon-forge-exclamation:before {
    content: "\\e917";
}
.icon-forge-progress-alert:before {
    content: "\\e900";
}
.icon-forge-check-circle-outline:before {
    content: "\\e901";
}
.icon-forge-check:before {
    content: "\\e902";
}
.icon-attention-solid:before {
    content: "\\e913";
}
.icon-sortable:before {
    content: "\\e910";
}
.icon-ascend:before {
    content: "\\e911";
}
.icon-descend:before {
    content: "\\e912";
}
.icon-unlink:before {
    content: "\\e903";
}
.icon-warning:before {
    content: "\\e904";
}
.icon-eye-closed:before {
    content: "\\e905";
}
.icon-attach:before {
    content: "\\e906";
}
.icon-grow-x:before {
    content: "\\e90a";
}
.icon-shrink-x:before {
    content: "\\e90b";
}
.icon-grow:before {
    content: "\\e907";
}
.icon-shrink-alt:before {
    content: "\\e908";
}
.icon-shrink:before {
    content: "\\e909";
}
.icon-grow-alt:before {
    content: "\\e90c";
}
.icon-user-solid:before {
    content: "\\e90d";
}
.icon-ellipsis-x:before {
    content: "\\e90e";
}
.icon-lg-calendar:before {
    content: "\\e90f";
}
.icon-lg-pay:before {
    content: "\\e914";
}
.icon-lg-workflow:before {
    content: "\\e915";
}
.icon-lg-tasks:before {
    content: "\\e916";
}
.icon-attention:before {
    content: "\\61";
}
.icon-info:before {
    content: "\\62";
}
.icon-nodes:before {
    content: "\\63";
}
.icon-caret-down:before {
    content: "\\6f";
}
.icon-caret-left:before {
    content: "\\70";
}
.icon-caret-right:before {
    content: "\\71";
}
.icon-caret-up:before {
    content: "\\72";
}
.icon-check:before {
    content: "\\73";
}
.icon-comment:before {
    content: "\\75";
}
.icon-download:before {
    content: "\\76";
}
.icon-eye:before {
    content: "\\77";
}
.icon-mail:before {
    content: "\\7a";
}
.icon-link:before {
    content: "\\41";
}
.icon-upload:before {
    content: "\\44";
}
.icon-undo:before {
    content: "\\45";
}
.icon-trash:before {
    content: "\\46";
}
.icon-settings:before {
    content: "\\47";
}
.icon-search:before {
    content: "\\49";
}
.icon-save:before {
    content: "\\4a";
}
.icon-redo:before {
    content: "\\4b";
}
.icon-publish:before {
    content: "\\4c";
}
.icon-edit:before {
    content: "\\4d";
}
.icon-sites:before {
    content: "\\4e";
}
.icon-folder:before {
    content: "\\78";
}
.icon-copy:before {
    content: "\\4f";
}
.icon-arrow-right:before {
    content: "\\51";
}
.icon-arrow-left:before {
    content: "\\52";
}
.icon-user:before {
    content: "\\54";
}
.icon-data:before {
    content: "\\55";
}
.icon-minus:before {
    content: "\\56";
}
.icon-plus:before {
    content: "\\57";
}
.icon-users:before {
    content: "\\59";
}
.icon-cloud:before {
    content: "\\31";
}
.icon-close:before {
    content: "\\74";
}
.icon-accessgov:before {
    content: "\\34";
}
.icon-ad:before {
    content: "\\35";
}
.icon-user-accessgov:before {
    content: "\\42";
}
.icon-user-ad:before {
    content: "\\43";
}
.icon-user-cloud:before {
    content: "\\53";
}
.icon-user-import:before {
    content: "\\58";
}
.icon-users-accessgov:before {
    content: "\\5a";
}
.icon-users-ad:before {
    content: "\\30";
}
.icon-users-cloud:before {
    content: "\\32";
}
.icon-users-import:before {
    content: "\\33";
}
.icon-ellipsis-y:before {
    content: "\\36";
}
.icon-drag:before {
    content: "\\38";
}
.icon-widget:before {
    content: "\\50";
}
.icon-open:before {
    content: "\\64";
}
.icon-lg-billing:before {
    content: "\\66";
}
.icon-lg-data:before {
    content: "\\67";
}
.icon-lg-users:before {
    content: "\\68";
}
.icon-lg-sites:before {
    content: "\\6b";
}
.icon-lg-setup:before {
    content: "\\6c";
}
.icon-lg-publish:before {
    content: "\\6d";
}
.icon-lg-settings:before {
    content: "\\6e";
}
.icon-lg-preview:before {
    content: "\\48";
}
.icon-lg-home:before {
    content: "\\21";
}
.icon-lg-history:before {
    content: "\\22";
}
.icon-lg-flag:before {
    content: "\\24";
}
.icon-lg-submissions:before {
    content: "\\69";
}
.icon-lg-stats:before {
    content: "\\6a";
}
.icon-lg-intro:before {
    content: "\\23";
}
.icon-lg-form:before {
    content: "\\39";
}
.icon-home:before {
    content: "\\79";
}
.icon-lg-code:before {
    content: "\\25";
}
.icon-lg-add-in:before {
    content: "\\65";
}
.icon-calculation:before {
    content: "\\26";
}
.icon-form:before {
    content: "\\29";
}
.icon-multi-text:before {
    content: "\\28";
}
.icon-quote:before {
    content: "\\2a";
}
.icon-text:before {
    content: "\\27";
}
`, "",{"version":3,"sources":["webpack://./icons/style.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB;;;6DAG6D;IAC7D,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,+EAA+E;IAC/E,mCAAmC;IACnC,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;;IAEd,sCAAsC;IACtC,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB","sourcesContent":["@font-face {\n    font-family: \"accessgov\";\n    src:\n        url(\"fonts/accessgov.ttf?1mwwnb\") format(\"truetype\"),\n        url(\"fonts/accessgov.woff?1mwwnb\") format(\"woff\"),\n        url(\"fonts/accessgov.svg?1mwwnb#accessgov\") format(\"svg\");\n    font-weight: normal;\n    font-style: normal;\n    font-display: block;\n}\n\n.icon:before {\n    /* use !important to prevent issues with browser extensions that change fonts */\n    font-family: \"accessgov\" !important;\n    speak: never;\n    font-style: normal;\n    font-weight: normal;\n    font-variant: normal;\n    text-transform: none;\n    line-height: 1;\n\n    /* Better Font Rendering =========== */\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-forge-exclamation:before {\n    content: \"\\e917\";\n}\n.icon-forge-progress-alert:before {\n    content: \"\\e900\";\n}\n.icon-forge-check-circle-outline:before {\n    content: \"\\e901\";\n}\n.icon-forge-check:before {\n    content: \"\\e902\";\n}\n.icon-attention-solid:before {\n    content: \"\\e913\";\n}\n.icon-sortable:before {\n    content: \"\\e910\";\n}\n.icon-ascend:before {\n    content: \"\\e911\";\n}\n.icon-descend:before {\n    content: \"\\e912\";\n}\n.icon-unlink:before {\n    content: \"\\e903\";\n}\n.icon-warning:before {\n    content: \"\\e904\";\n}\n.icon-eye-closed:before {\n    content: \"\\e905\";\n}\n.icon-attach:before {\n    content: \"\\e906\";\n}\n.icon-grow-x:before {\n    content: \"\\e90a\";\n}\n.icon-shrink-x:before {\n    content: \"\\e90b\";\n}\n.icon-grow:before {\n    content: \"\\e907\";\n}\n.icon-shrink-alt:before {\n    content: \"\\e908\";\n}\n.icon-shrink:before {\n    content: \"\\e909\";\n}\n.icon-grow-alt:before {\n    content: \"\\e90c\";\n}\n.icon-user-solid:before {\n    content: \"\\e90d\";\n}\n.icon-ellipsis-x:before {\n    content: \"\\e90e\";\n}\n.icon-lg-calendar:before {\n    content: \"\\e90f\";\n}\n.icon-lg-pay:before {\n    content: \"\\e914\";\n}\n.icon-lg-workflow:before {\n    content: \"\\e915\";\n}\n.icon-lg-tasks:before {\n    content: \"\\e916\";\n}\n.icon-attention:before {\n    content: \"\\61\";\n}\n.icon-info:before {\n    content: \"\\62\";\n}\n.icon-nodes:before {\n    content: \"\\63\";\n}\n.icon-caret-down:before {\n    content: \"\\6f\";\n}\n.icon-caret-left:before {\n    content: \"\\70\";\n}\n.icon-caret-right:before {\n    content: \"\\71\";\n}\n.icon-caret-up:before {\n    content: \"\\72\";\n}\n.icon-check:before {\n    content: \"\\73\";\n}\n.icon-comment:before {\n    content: \"\\75\";\n}\n.icon-download:before {\n    content: \"\\76\";\n}\n.icon-eye:before {\n    content: \"\\77\";\n}\n.icon-mail:before {\n    content: \"\\7a\";\n}\n.icon-link:before {\n    content: \"\\41\";\n}\n.icon-upload:before {\n    content: \"\\44\";\n}\n.icon-undo:before {\n    content: \"\\45\";\n}\n.icon-trash:before {\n    content: \"\\46\";\n}\n.icon-settings:before {\n    content: \"\\47\";\n}\n.icon-search:before {\n    content: \"\\49\";\n}\n.icon-save:before {\n    content: \"\\4a\";\n}\n.icon-redo:before {\n    content: \"\\4b\";\n}\n.icon-publish:before {\n    content: \"\\4c\";\n}\n.icon-edit:before {\n    content: \"\\4d\";\n}\n.icon-sites:before {\n    content: \"\\4e\";\n}\n.icon-folder:before {\n    content: \"\\78\";\n}\n.icon-copy:before {\n    content: \"\\4f\";\n}\n.icon-arrow-right:before {\n    content: \"\\51\";\n}\n.icon-arrow-left:before {\n    content: \"\\52\";\n}\n.icon-user:before {\n    content: \"\\54\";\n}\n.icon-data:before {\n    content: \"\\55\";\n}\n.icon-minus:before {\n    content: \"\\56\";\n}\n.icon-plus:before {\n    content: \"\\57\";\n}\n.icon-users:before {\n    content: \"\\59\";\n}\n.icon-cloud:before {\n    content: \"\\31\";\n}\n.icon-close:before {\n    content: \"\\74\";\n}\n.icon-accessgov:before {\n    content: \"\\34\";\n}\n.icon-ad:before {\n    content: \"\\35\";\n}\n.icon-user-accessgov:before {\n    content: \"\\42\";\n}\n.icon-user-ad:before {\n    content: \"\\43\";\n}\n.icon-user-cloud:before {\n    content: \"\\53\";\n}\n.icon-user-import:before {\n    content: \"\\58\";\n}\n.icon-users-accessgov:before {\n    content: \"\\5a\";\n}\n.icon-users-ad:before {\n    content: \"\\30\";\n}\n.icon-users-cloud:before {\n    content: \"\\32\";\n}\n.icon-users-import:before {\n    content: \"\\33\";\n}\n.icon-ellipsis-y:before {\n    content: \"\\36\";\n}\n.icon-drag:before {\n    content: \"\\38\";\n}\n.icon-widget:before {\n    content: \"\\50\";\n}\n.icon-open:before {\n    content: \"\\64\";\n}\n.icon-lg-billing:before {\n    content: \"\\66\";\n}\n.icon-lg-data:before {\n    content: \"\\67\";\n}\n.icon-lg-users:before {\n    content: \"\\68\";\n}\n.icon-lg-sites:before {\n    content: \"\\6b\";\n}\n.icon-lg-setup:before {\n    content: \"\\6c\";\n}\n.icon-lg-publish:before {\n    content: \"\\6d\";\n}\n.icon-lg-settings:before {\n    content: \"\\6e\";\n}\n.icon-lg-preview:before {\n    content: \"\\48\";\n}\n.icon-lg-home:before {\n    content: \"\\21\";\n}\n.icon-lg-history:before {\n    content: \"\\22\";\n}\n.icon-lg-flag:before {\n    content: \"\\24\";\n}\n.icon-lg-submissions:before {\n    content: \"\\69\";\n}\n.icon-lg-stats:before {\n    content: \"\\6a\";\n}\n.icon-lg-intro:before {\n    content: \"\\23\";\n}\n.icon-lg-form:before {\n    content: \"\\39\";\n}\n.icon-home:before {\n    content: \"\\79\";\n}\n.icon-lg-code:before {\n    content: \"\\25\";\n}\n.icon-lg-add-in:before {\n    content: \"\\65\";\n}\n.icon-calculation:before {\n    content: \"\\26\";\n}\n.icon-form:before {\n    content: \"\\29\";\n}\n.icon-multi-text:before {\n    content: \"\\28\";\n}\n.icon-quote:before {\n    content: \"\\2a\";\n}\n.icon-text:before {\n    content: \"\\27\";\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
